import { defineMessages } from "react-intl";

export const columnsMessages = defineMessages({
  name: {
    id: "W32xfN",
    defaultMessage: "Name",
    description: "staff member full name",
  },
  email: {
    id: "xxQxLE",
    defaultMessage: "Email Address",
  },
  status: {
    id: "tzMNF3",
    defaultMessage: "Status",
  },
});

export const messages = defineMessages({
  empty: {
    id: "xJQX5t",
    defaultMessage: "No staff members found",
  },
});
